import React from 'react';

const SECTION = ({ title, children }) => (
  <div className="card" style={{ marginBottom: '1rem' }}>
    <div className="section-kicker" style={{ marginBottom: '0.75rem' }}>
      {title}
    </div>
    <div style={{ color: 'var(--text-muted)', fontSize: 'var(--t-sm)', lineHeight: 1.8 }}>
      {children}
    </div>
  </div>
);

export default function PrivacyNotice() {
  return (
    <div className="page-container" style={{ maxWidth: '680px' }}>
      <h2 style={{ marginBottom: '0.25rem' }}>Privacy Notice</h2>
      <p style={{ color: 'var(--text-faint)', fontSize: 'var(--t-sm)', marginBottom: '1.5rem' }}>
        WC2026 Predictor — last updated 12 June 2026
      </p>

      <SECTION title="Who we are">
        <p>WC2026 Predictor is a private prediction game run by Remy Hargreaves for invited participants. It is not a commercial service.</p>
      </SECTION>

      <SECTION title="What data we collect">
        <ul style={{ paddingLeft: '1.25rem', margin: 0 }}>
          <li>Your name and email address (provided at sign-up)</li>
          <li>Your match predictions and tournament winner pick</li>
          <li>Your preference for email reminders</li>
          <li>A record of your acceptance of these terms, including timestamp and IP address</li>
          <li>A log of significant account actions (login, password changes, prediction saves)</li>
        </ul>
      </SECTION>

      <SECTION title="How we use your data">
        <ul style={{ paddingLeft: '1.25rem', margin: 0 }}>
          <li><strong>Providing the service</strong> — displaying your predictions and leaderboard position to other participants</li>
          <li><strong>Email reminders</strong> — if you opt in, sending you a single reminder email approximately one hour before each matchday when you have unpredicted matches</li>
          <li><strong>Security &amp; audit</strong> — maintaining a log of account actions to detect abuse</li>
        </ul>
        <p style={{ marginTop: '0.75rem' }}>We do not use your data for advertising, profiling, or any purpose beyond running this game.</p>
      </SECTION>

      <SECTION title="Legal basis (UK GDPR)">
        <p>We process your data on the basis of <strong>legitimate interests</strong> (running the prediction game for invited participants) and <strong>consent</strong> for email reminders. You can withdraw consent for reminders at any time in your Account settings.</p>
      </SECTION>

      <SECTION title="Data sharing">
        <p>Your name and predictions are visible to other participants in shared leagues. Your email address is never shown to other participants. We do not sell or share your data with third parties except as necessary to operate the service (AWS cloud infrastructure in the USA, subject to Standard Contractual Clauses).</p>
      </SECTION>

      <SECTION title="Retention">
        <p>Your data is retained for the duration of the tournament and up to 90 days afterwards, after which accounts and predictions are deleted. You may request earlier deletion at any time (see below).</p>
      </SECTION>

      <SECTION title="Your rights">
        <p>Under UK GDPR you have the right to:</p>
        <ul style={{ paddingLeft: '1.25rem', margin: '0.5rem 0' }}>
          <li><strong>Access</strong> — request a copy of the data we hold about you</li>
          <li><strong>Rectification</strong> — correct inaccurate data (use Account → Display Name)</li>
          <li><strong>Erasure</strong> — delete your account and all associated data via Account → Delete Account</li>
          <li><strong>Withdraw consent</strong> — turn off email reminders at any time in Account settings</li>
          <li><strong>Complaint</strong> — lodge a complaint with the ICO (ico.org.uk) if you believe your data has been mishandled</li>
        </ul>
      </SECTION>

      <SECTION title="Contact">
        <p>For any privacy questions or data requests, email <a href="mailto:remyg.hargreaves@gmail.com" style={{ color: 'var(--volt)' }}>remyg.hargreaves@gmail.com</a>.</p>
      </SECTION>
    </div>
  );
}
